import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../ReduxToolkit/Hooks';
import { Image, SVG } from '../../AbstractElements';
import { setToggleSidebar } from '../../ReduxToolkit/Reducers/LayoutSlice';
import { dynamicImage } from '../../Service';

const LogoWrapper = () => {
    const dispatch = useAppDispatch();
    const {toggleSidebar} = useAppSelector((state)=>state.layout)

    return (
      <>
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
            <Image className="img-fluid" src={"https://gleads.vn/assets/common/logoWhite.svg"} alt="logo" />
          </Link>
          <div className="toggle-sidebar">
            <SVG className={`sidebar-toggle`} iconId={`toggle-icon`} onClick={()=>dispatch(setToggleSidebar(!toggleSidebar))}/>
          </div>
        </div>
        <div className="logo-icon-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
            <Image className="img-fluid" src={"https://gleads.vn/assets/common/logoWhite.svg"} alt="logo" />
          </Link>
        </div>
      </>
    );
}

export default LogoWrapper